export default "__VITE_ASSET__MRisjj4m__"